import { useStore } from '@lib/context/store-context';
import { ButtonPrimary } from '@modules/common/components/form/buttons/button-primary';
import { ButtonSecondary } from '@modules/common/components/form/buttons/button-secondary';
import { useCart } from 'medusa-react';
import { useEffect, useState } from 'react';
import { Bounce, toast } from 'react-toastify';
import Link from 'next/link';
import { GenerateAdRollScript, PixelImg } from '@modules/common/components/yelp-pixel/yelp-pixel';
import { CARD_PROGRAMS } from '@lib/constants';
import { LET_THEM_CHOOSE } from '@lib/constants/variants';

type Props = {
  disabled?: boolean;
  businessName?: string;
  isDisabledButton?: boolean;
};

const RESTAURANTS_SPAS_SALONS_CHOICE_MESSAGE = 'Restaurants, Spas and Salons of Their Choice';
const RESTAURANTS_CHOICE_MESSAGE = 'Restaurant of Their Choice';
const SPAS_SALONS_CHOICE_MESSAGE = 'Spa or Salon of Their Choice';
const SERVICE_PROVIDERS_CHOICE_MESSAGE = 'Service Providers of Their Choice';

const ButtonGroupBuyAdd = (props: Props) => {
  const { totalItems } = useCart();
  const { disabled, businessName, isDisabledButton } = props;
  const { setLoading, setBuyNow } = useStore();
  const [lastCount, setLastCount] = useState<number>(totalItems);

  useEffect(() => {
    if (totalItems > 1 && totalItems === lastCount + 2) {
      let CHOICE_MESSAGE = RESTAURANTS_CHOICE_MESSAGE;
      const showToast = (message: JSX.Element, isError: boolean = true) => {
        toast[isError ? 'error' : 'success'](message, {
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          transition: isError ? undefined : Bounce,
        });
      };
      if (typeof window !== 'undefined') {
        const cardProgram = sessionStorage.getItem(CARD_PROGRAMS.KEY);
        CHOICE_MESSAGE = SPAS_SALONS_CHOICE_MESSAGE;
        switch (cardProgram){
          case CARD_PROGRAMS.CHOOSE_YOUR_OWN_RESTAURANTS_SPAS_SALONS:
            CHOICE_MESSAGE = RESTAURANTS_SPAS_SALONS_CHOICE_MESSAGE;
            break;
          case CARD_PROGRAMS.CHOOSE_YOUR_OWN_RESTAURANT:
          case CARD_PROGRAMS.CHOOSE_YOUR_OWN_RESTAURANT_BARS:
          case CARD_PROGRAMS.CHOOSE_YOUR_OWN_RESTAURANT_COFFEE:
            CHOICE_MESSAGE = RESTAURANTS_CHOICE_MESSAGE;
            break;
          case CARD_PROGRAMS.CHOOSE_YOUR_OWN_SPAS_SALONS:
            CHOICE_MESSAGE = SPAS_SALONS_CHOICE_MESSAGE;
            break;
          case CARD_PROGRAMS.CHOOSE_YOUR_OWN_HOME_SERVICES:
          case CARD_PROGRAMS.CHOOSE_YOUR_OWN_PERSONAL_SERVICES:
          case CARD_PROGRAMS.CHOOSE_YOUR_OWN_AUTO_SERVICES:
            CHOICE_MESSAGE = SERVICE_PROVIDERS_CHOICE_MESSAGE;
            break;
        }
      }
      showToast(
        <div>
          {businessName && businessName != LET_THEM_CHOOSE  ? businessName :  CHOICE_MESSAGE} added to cart
          <br />
          <div className="static-content">
            <Link href="/cart" prefetch={false}>Go To Cart</Link>
          </div>
        </div>,
        false
      );

      setLastCount(totalItems);
    }
  }, [totalItems]);

  return (
    <div className="flex gap-2 mt-2">
      <div className="card__form__action__button">
        <ButtonSecondary
          id="add-to-cart"
          size="medium"
          type="submit"
          variant="optimus_prime"
          onClick={() => {
            if (!disabled) {
              setBuyNow(false);
              GenerateAdRollScript({ segment_name: 'c88a3a05' });
            }
          }}
          className={`!max-h-[42px] ${isDisabledButton ? 'buttonSecondary--disabled' : ''}`}
          disabled={isDisabledButton}
        >
          Add to Cart
          <PixelImg src="ct=0:ws9tka3&fmt=3"/>
        </ButtonSecondary>
      </div>
      <div className="card__form__action__button">
        <ButtonPrimary
          id="buy-now"
          size="medium"
          type="submit"
          onClick={() => {
            if (!disabled) {
              setBuyNow(true);
              setLoading(true);
            }
          }}
          variant="primary"
          className={`${isDisabledButton ? 'ButtonPrimary--disabled' : ''}`}
          disabled={isDisabledButton}
        >
          Buy Now!
        </ButtonPrimary>
      </div>
    </div>
  );
};

export default ButtonGroupBuyAdd;
